import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/15/thumb-landscape.jpg"

const Post15 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">
        奥から順に<br></br>
        STELLA McCARTNEY／ファラベラ／36 x36 x8cm<br></br>
        STELLA McCARTNEY／ファラベラ／26 x25 x9cm<br></br>
        STELLA McCARTNEY／ファラベラ／17 x18 x6cm
      </span>     
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          ステラ・マッカートニー（STELLA McCARTNEY）は、クロエのクリエイティブ・ディレクターとして活躍していたデザイナーが自身の名を冠し、2001年にイギリスで創立されたブランド。<br></br>動物愛好家でもある彼女が手がけるバッグは、ファーやレザーを一切使用していないことでも有名で、エシカルファッションの先駆けとも言えるべき存在。今回は、ラクサスで人気のステラ・マッカートニーのブランドバッグ10選をご紹介します♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ステラ ロゴ トートバッグ</h2>
          <p>洗練されたロゴデザインと可愛らしい立体的なフォルムが魅力的な「ステラ ロゴ トートバッグ」。ステラの特徴ともいえる上質な合成皮革は、一般的なレザーより軽くお手入れもしやすいので、ビジネスカジュアルやデイリー使いにぴったりなバッグです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/15/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">STELLA McCARTNEY／トートバッグ／40 x30 x15cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/3.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／トートバッグ／40 x30 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/4.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／トートバッグ／40 x31 x14cm</span> 
          </figure>          
        </div>   
        <div className="text-max-width">
          <h2>ファラベラ</h2>
          <p>ステラの代表的アイテムである「ファラベラ」。スタイリッシュなデザイン性だけでなく、表面は動物の毛皮を使用しない人工の素材「クルーエルティフリー」、裏地はペットボトルのリサイクル素材で出来た環境にも優しいバッグ。サイズは、Tiny(タイニー)/Mini(ミニ)/Small(スモール)/Small(スモール)の4展開。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/6.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">STELLA McCARTNEY／ファラベラ／36 x36 x8cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/7.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラ／33 x33 x8cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/8.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラ／36 x36 x8cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ステラ ロゴ ミニバッグ</h2>
          <p>ころんとしたフォルムが可愛らしいカメラバッグタイプの「ステラ ロゴ ミニバッグ」。ショルダーの大きなロゴ刺繍がワンポイントになり、ぐっとおしゃれな印象に。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/15/9.jpg" alt="" />
        </figure>   
        <span className="text-center">STELLA McCARTNEY／ショルダーバッグ／17 x17 x5cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/10.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ショルダーバッグ／17 x17 x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/11.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ショルダーバッグ／20 x17 x5cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ファラベラGOバックパック</h2>
          <p>「ファラベラGOバックパック」はジップポケットとハンドルにあしらわれたチェーンがアイコニック。シンプルで高級感のあるデザインは、いつものカジュアルコーデを格上げしてくれるアイテムです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/12.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/13.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">STELLA McCARTNEY／ファラベラ／18 x25 x10cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/14.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラ／26 x40 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/15.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラバックパック／18 x25 x10cm</span> 
          </figure>
        </div>    
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          ステラ・マッカートニーのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>ステラ ロゴ ショルダーバッグ</h2>
          <p>普段使いしやすいミニマルなデザインとサイズ感が人気の「ステラ ロゴ ショルダーバッグ」。内側のメインコパーメントにはオープンポケットが備えられています。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/16.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/17.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">STELLA McCARTNEY／ショルダーバッグ／23 x22 x8cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/18.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/19.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">STELLA McCARTNEY／ショルダーバッグ／23 x23 x8cm</span>      
        <div className="text-max-width">
        <h2>ステラ ロゴ クロスボディバッグ</h2>
        <p>「ステラ ロゴ トート」にショルダーが付いたタイプ。ショルダーは取り外し可能なのでシーンや用途に合わせて使い分けができるのも嬉しいポイント。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/20.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/21.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">STELLA McCARTNEY／2WAYバッグ／30 x23 x12cm</span>   
        <div className="text-max-width">
          <h2>ファラベラボックス</h2>
          <p>かっちりとしたフォルムがスタイリッシュな「ファラベラボックス」。小ぶりながらも、ラウンドファスナー仕様で物の出し入れがしやすく、マチが広めなので見た目以上に収納力があります。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/22.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/23.jpg" alt="" />
          </figure>          
        </div>
        <span className="text-center">STELLA McCARTNEY／ファラベラボックス／24 x17 x10cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/24.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラボックス／23 x18 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/25.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラボックスショルダーバッグ／22 x18 x5cm</span> 
          </figure>          
        </div>  
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          ステラ・マッカートニーのバッグを見る
        </Link>                     
        <div className="text-max-width">
          <h2>ファラベラトート</h2>
          <p>使い勝手の良いサイズ感とやわらかな生地感がデイリー使いにぴったりな「ファラベラトート」。表裏使えるリバーシブルタイプなので、好みや気分によって２つの表情を楽しむことができます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/26.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/27.jpg" alt="" />
          </figure>          
        </div>    
        <span className="text-center">STELLA McCARTNEY／ファラベラ／37 x35 x10cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/28.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/29.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">STELLA McCARTNEY／ファラベラリバーシブル／24 x23 x10cm</span>           
        <div className="text-max-width">
          <h2>ステラスターショルダーバッグ</h2>
          <p>スター型キルティングと、シルバーのスターモチーフが目を惹くモード感たっぷりの「ステラスターショルダーバッグ」。コンパクトなサイズ感ながらマチが広めなので見た目以上に収納力のあるバッグです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/30.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/31.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">STELLA McCARTNEY／スモールショルダーバッグ／22 x14 x7cm</span>       
        <div className="text-max-width">
          <h2>ファラベラショルダー</h2>
          <p>肩にさっとかけるだけで、ラグジュアリーな印象をプラスしてくれる「ファラベラショルダー」は、ちょっとしたお出掛けやパーティーシーンに大活躍のバッグ。横幅が広めなので長財布を入れやすいのもポイント。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/32.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/33.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">STELLA McCARTNEY／ファラベラ／34 x23 x9cm</span>              
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/34.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラ／24 x15 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/15/35.jpg" alt="" />
            <span className="text-center">STELLA McCARTNEY／ファラベラ／21 x12 x4cm</span> 
          </figure>
        </div>   
        <div className="text-two-cloumn">
          <h2>デザイナーの信念が詰まったステラ・マッカートニー<br className="pc"></br>のバッグ</h2>
          <p>モードで都会的なデザインの中に、素材に対するデザイナーの信念が詰まったステラ・マッカートニーのバッグ。ラクサスでも多数扱っていますので、ぜひオシャレの参考に覗いてみてくださいね♪</p>
        </div>                                   
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          ステラ・マッカートニーのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post15

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 15}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
